import { useEffect, useState } from "react";
import api, { CATEGORIES } from "@/lib/api";
import { Hero } from "@/components/home/Hero";
import { CategoryGrid, LatestListings, PostCta } from "@/components/home/HomeSections";

const fetchTotal = (slug) =>
  api.get("/listings", { params: { category: slug, limit: 1 } }).then((r) => r.data.total || 0).catch(() => 0);

export default function Home() {
  const [listings, setListings] = useState([]);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api.get("/listings", { params: { limit: 20 } }).then(({ data }) => setListings(data.items || []));
    Promise.all(CATEGORIES.map((c) => fetchTotal(c.slug)))
      .then((totals) => setCounts(Object.fromEntries(CATEGORIES.map((c, i) => [c.slug, totals[i]]))));
  }, []);

  const totalListings = listings.length > 0 ? Object.values(counts).reduce((a, b) => a + b, 0) : null;

  return (
    <div data-testid="home-page">
      <Hero totalListings={totalListings} />
      <CategoryGrid counts={counts} />
      <LatestListings listings={listings} />
      <PostCta />
    </div>
  );
}
